import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import Lastmenu from "./Lastmenu";
import { AuthContext } from "../../context/AuthContext";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";


/**
 * Permet d'afficher les sous liens d'une catégorie dans la Sidebar
 * @param {array} submenu - liste des liens du sous menu
 * @param {number} index - of item in submenu array
 * @param {string} secondDrop - permet de définir si une sous catégorie est ouverte ou fermer
 * @param {object} thirdDrop - défini si un lien dans une sous catégorie est ouvert ou fermer 
 */

export default function Submenu({
  submenu,
  index,
  secondDrop,
  thirdDrop,
}) {
  // import role and control
  const { t } = useTranslation();
  const { user, entrepriseRoles } = useContext(AuthContext);
  const shouldDisplayMenu = submenu.role
    ? submenu.role.some((role) => entrepriseRoles.includes(role) || user.roles.includes(role))
    : true;

  return (
    <>
      {shouldDisplayMenu && submenu.path && (
        <li className="submenu-item">
          {submenu.path.includes("http") ? (
            <a style={{ display: "flex", alignItems: "center"}} href={submenu.path} target={"_blank"} className="submenu-link">
              {t(submenu.title)}
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                style={{ marginLeft: '5px', fontSize: '1rem', opacity: 0.8 }}
              />
            </a>
          ) : (
            <div className="submenu-link">
              <NavLink to={submenu.path} className="submenu_link">
                {t(submenu.title)}
              </NavLink>
            </div>
          )}
          {submenu.lastmenu ? (
            <ul
              className={`lastmenu-list ${thirdDrop === `${secondDrop}${index}`
                  ? "lastmenu-list_open"
                  : ""
                }`}
            >
              {submenu.lastmenu.map((lastmenu, index) => {
                return (
                  <Lastmenu lastmenu={lastmenu} index={index} key={index} />
                );
              })}
            </ul>
          ) : null}
        </li>
      )}
    </>
  );
}
